module.exports = __webpack_public_path__ + "static/you-cew-1-e37d074375e1c4c6a54f7203c1737b39.jpg";